import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateDailyCheckIn from '@/modules/promotion/api/hooks/useMutateUpdateDailyCheckIn'
import { useQueryClient } from '@tanstack/react-query'
import { DailyCheckInQueryKeys } from '@/modules/promotion/keys'
import { GetDailyCheckInByIdResponse } from '@/modules/promotion/type'
import { useParams } from 'react-router-dom'

interface RequireConnectedLineDailyCheckInProps {
	dailyCheckInData: GetDailyCheckInByIdResponse
	onUpdate?: (requireConnectedLine: boolean) => void
	mode: 'create' | 'edit'
}

export function RequireConnectedLineDailyCheckIn({
	dailyCheckInData,
	onUpdate,
	mode,
}: RequireConnectedLineDailyCheckInProps) {
	const queryClient = useQueryClient()
	const { id } = useParams()
	const { mutateAsync: updateDailyCheckIn } = useMutationUpdateDailyCheckIn()

	const handleMutate = async (value: boolean) => {
		// Only make API call in edit mode
		if (mode === 'edit' && id) {
			await updateDailyCheckIn({
				id: id,
				payload: {
					name: dailyCheckInData.name,
					isActive: dailyCheckInData.isActive,
					requireConnectedLine: value,
					checkInSetting: dailyCheckInData.checkInSetting,
					turnoverRound: dailyCheckInData.turnoverRound,
				},
			})

			// Invalidate queries to refresh the data
			queryClient.invalidateQueries({
				queryKey: [DailyCheckInQueryKeys.GetDailyCheckIn],
			})
			queryClient.invalidateQueries({
				queryKey: [DailyCheckInQueryKeys.GetDailyCheckInById, id],
			})
		}

		// Call the optional callback to update parent component
		onUpdate?.(value)
	}

	return (
		<div className="flex items-center gap-3">
			<span className="text-sm font-medium">ต้องเชื่อมต่อ LINE</span>
			<SetIsActive
				defaultChecked={dailyCheckInData.requireConnectedLine ?? false}
				onMutate={handleMutate}
				errorMessage="ไม่สามารถอัพเดทการเชื่อมต่อ LINE ได้"
				disabled={mode === 'create'} // Disable in create mode since there's no ID yet
			/>
		</div>
	)
}
